import { render, staticRenderFns } from "./VendorApisView.vue?vue&type=template&id=4069c4d0&lang=pug&"
import script from "./VendorApisView.vue?vue&type=script&lang=ts&"
export * from "./VendorApisView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports